"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assetsGetPresigned = exports.assetUpdateAccessPermission = exports.assetUpdate = exports.assetSuccess = exports.assetReset = exports.assetReportCoverImageList = exports.assetList = exports.assetGetAccessPermission = exports.assetError = exports.assetDownloadUrl = exports.assetDownload = exports.assetDelete = exports.assetCreate = exports.assetCoverImageList = exports.assetAddAccessPermission = exports.assePreviewDoc = exports.assePreview = void 0;
var _asset = require("./asset.constant");
// @flow

// common success
var assetSuccess = function assetSuccess(actionType, data) {
  return {
    type: _asset.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.assetSuccess = assetSuccess;
var assetError = function assetError(actionType, error) {
  return {
    type: _asset.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * create
 * @param payload
 * @returns api response
 * @description this function used to add data.
 */
exports.assetError = assetError;
var assetCreate = function assetCreate(data) {
  return {
    type: _asset.actionTypes.CREATE,
    payload: data
  };
};

/**
 * download
 * @param payload
 * @returns api response
 * @description this function used to download data.
 */
exports.assetCreate = assetCreate;
var assetDownload = function assetDownload(data) {
  return {
    type: _asset.actionTypes.DOWNLOAD,
    payload: data
  };
};

/**
 * download
 * @param payload
 * @returns api response
 * @description this function used to download data.
 */
exports.assetDownload = assetDownload;
var assetDownloadUrl = function assetDownloadUrl(data) {
  return {
    type: _asset.actionTypes.DOWNLOAD_URL,
    payload: data
  };
};

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
exports.assetDownloadUrl = assetDownloadUrl;
var assetUpdate = function assetUpdate(data) {
  return {
    type: _asset.actionTypes.UPDATE,
    payload: data
  };
};

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.assetUpdate = assetUpdate;
var assetList = function assetList(data) {
  return {
    type: _asset.actionTypes.LIST,
    payload: data
  };
};

/**
 * delete
 * @param payload
 * @returns api response
 * @description this function used to delete data.
 */
exports.assetList = assetList;
var assetDelete = function assetDelete(data) {
  return {
    type: _asset.actionTypes.DELETE,
    payload: data
  };
};

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.assetDelete = assetDelete;
var assePreview = function assePreview(data) {
  return {
    type: _asset.actionTypes.PREVIEW,
    payload: data
  };
};

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.assePreview = assePreview;
var assePreviewDoc = function assePreviewDoc(data) {
  return {
    type: _asset.actionTypes.PREVIEW_DOC,
    payload: data
  };
};

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
exports.assePreviewDoc = assePreviewDoc;
var assetUpdateAccessPermission = function assetUpdateAccessPermission(data) {
  return {
    type: _asset.actionTypes.UPDATE_ACCESS_PERMISSION,
    payload: data
  };
};

/**
 * create
 * @param payload
 * @returns api response
 * @description this function used to create data.
 */
exports.assetUpdateAccessPermission = assetUpdateAccessPermission;
var assetAddAccessPermission = function assetAddAccessPermission(data) {
  return {
    type: _asset.actionTypes.CREATE_ACCESS_PERMISSION,
    payload: data
  };
};

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.assetAddAccessPermission = assetAddAccessPermission;
var assetCoverImageList = function assetCoverImageList(data) {
  return {
    type: _asset.actionTypes.COVER_IMAGE,
    payload: data
  };
};

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.assetCoverImageList = assetCoverImageList;
var assetReportCoverImageList = function assetReportCoverImageList(data) {
  return {
    type: _asset.actionTypes.REPORT_COVER_IMAGE,
    payload: data
  };
};

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.assetReportCoverImageList = assetReportCoverImageList;
var assetGetAccessPermission = function assetGetAccessPermission(data) {
  return {
    type: _asset.actionTypes.GET_ACCESS_PERMISSION,
    payload: data
  };
};

/**
 * fetch presigned assets
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.assetGetAccessPermission = assetGetAccessPermission;
var assetsGetPresigned = function assetsGetPresigned(data) {
  return {
    type: _asset.actionTypes.GET_ASSETS_PRESIGNED,
    payload: data
  };
};

/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to reset data.
 */
exports.assetsGetPresigned = assetsGetPresigned;
var assetReset = function assetReset() {
  return {
    type: _asset.actionTypes.RESET
  };
};
exports.assetReset = assetReset;